
import { 
  Minimize2, 
  LayoutGrid, 
  Columns, 
  Maximize2 
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Scaling } from "lucide-react";
import { useEffect } from "react";

interface WidgetResizeControlProps {
  currentSize: 'small' | 'medium' | 'large' | 'xlarge';
  onResize: (newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
  className?: string;
}

export function WidgetResizeControl({ 
  currentSize, 
  onResize,
  className = "" 
}: WidgetResizeControlProps) {
  // Add debugging for currentSize changes
  useEffect(() => {
    console.log('WidgetResizeControl currentSize:', currentSize);
  }, [currentSize]);

  const handleResize = (newSize: 'small' | 'medium' | 'large' | 'xlarge') => {
    console.log('WidgetResizeControl: Resizing to', newSize, 'from', currentSize);
    onResize(newSize);
  };

  return (
    <div className={`absolute bottom-2 right-2 z-10 ${className}`}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-6 w-6 rounded-full bg-muted/60 backdrop-blur-sm">
            <Scaling className="h-3.5 w-3.5" />
            <span className="sr-only">Resize widget</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem 
            onClick={() => handleResize('small')} 
            disabled={currentSize === 'small'}
          >
            <Minimize2 className="h-4 w-4 mr-2" />
            <span>Small</span>
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => handleResize('medium')} 
            disabled={currentSize === 'medium'}
          >
            <LayoutGrid className="h-4 w-4 mr-2" />
            <span>Medium</span>
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => handleResize('large')} 
            disabled={currentSize === 'large'}
          >
            <Columns className="h-4 w-4 mr-2" />
            <span>Large</span>
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => handleResize('xlarge')} 
            disabled={currentSize === 'xlarge'}
          >
            <Maximize2 className="h-4 w-4 mr-2" />
            <span>X-Large</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
